import { useState, useEffect } from 'react';
import usePieChartHoverEffect from '@intelligence/components/Chart/hooks/usePieChartsHoverEffect';

import type { ChartType } from '@intelligence/pages/TopCharts/_config/enums';
import type { IChartsIndexInstance } from '@intelligence/components/ChartsComponents/ChartsIndex';

const getSafeOptions = (options: any): any => {
  return options || {};
};

export default function useOptionsExtend(props: {
  loading: boolean;
  chartType: ChartType;
  chartsInstance: React.MutableRefObject<IChartsIndexInstance>;
  options: any;
}) {
  const {
    loading,
    chartType,
    chartsInstance,
    options: propsOptions,
  } = props;

  const [options, setOptions] = useState(getSafeOptions(propsOptions));

  useEffect(() => {
    const propsOptionsTmp = getSafeOptions(propsOptions);
    setOptions(propsOptionsTmp);
  }, [propsOptions]);

  const {
    onHighlight,
    onDownplay,
  } = usePieChartHoverEffect({
    loading,
    chartType,
    chartsInstance,
    setOption: setOptions,
  });

  return {
    options,
    onHighlight,
    onDownplay,
  };
}
